import ExpandSpoiler from 'scripts/defa/behaviors/expand-spoiler';
import FormEnabler   from 'scripts/defa/behaviors/form-enabler';
import ViewAnimator  from 'scripts/defa/behaviors/view-animator';
import Module        from 'scripts/module';

const BehaviorModule = new Module('BehaviorModule',{
	behaviors: {
		ExpandSpoiler,
		FormEnabler,
		ViewAnimator
	}
});

export default BehaviorModule